// A hub's demand: asks it didn't answer. See Design > Exchange, "Events and demand".

import type { DemandItem, DemandResponse } from "./types.ts";

export type DemandGroup = "declined" | "outranked" | "missed";
export const DEMAND_GROUPS: DemandGroup[] = ["declined", "outranked", "missed"];
export const DEMAND_DAYS = [7, 30, 90] as const;

/** One group's asks matching a search, by money offered (count × bid), then count. */
export function demandRows(d: DemandResponse, group: DemandGroup, search = ""): DemandItem[] {
  const q = search.trim().toLowerCase();
  return d[group].items
    .filter((item) => !q || item.question.toLowerCase().includes(q) || (item.reason ?? "").toLowerCase().includes(q))
    .sort((a, b) => b.count * b.bidUsd - a.count * a.bidUsd || b.count - a.count || b.lastAt - a.lastAt);
}

/** Asks that went to another hub or never reached this one. */
export const wentElsewhere = (d: DemandResponse) => d.outranked.questions + d.missed.questions;
